<h3>{{('common.restaurant.type.' + restaurantType) | translate}}</h3>

<table class="_tableColor">
    <thead>
    <tr class="_titlePartTable">
        <th [i18nKey]="'area.competition.team.number'"></th>
        <th [i18nKey]="'area.competition.team.name'"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let rival of rivals">
        <td>{{rival.teamNumber}}</td>
        <td>{{rival.name}}</td>
    </tr>
    </tbody>
</table>
